import Claims from 'Agent/Claims/components/Claims';
import PolicyRouteConstants from 'Agent/Policies/PolicyRouteConstants';
import React from 'react';
import {Route, RouteComponentProps} from 'react-router-dom';
import {AgencyFilters} from 'Shared/models/AgencyFilters';

type ClaimsRouteProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

export default ({selectedAgency}: ClaimsRouteProps) => (
  <Route
    exact
    path={`${PolicyRouteConstants.POLICIES}/:policyNumber/claims`}
    render={routeProps => <Claims {...routeProps} selectedAgency={selectedAgency} />}
  />
);
